<template>
  <Popup
    title="新增报警器"
    minHeight="100%"
    ref="popup"
    @on-closed="showForm = flase"
  >
    <div v-if="showForm" class="container">
      <van-form @submit="handleSubmit">
        <Field
          name="eqId"
          label="设备ID"
          :rules="[
            { required: true, message: '请输入设备ID' },
            {
              validator: asyncValidator,
              message: '设备ID被占用'
            }
          ]"
        />
        <Field name="eqName" label="设备名称" :require="true" />
        <Field name="eqPosition" label="设备位置" :require="true" />
        <Field name="eqModel" label="设备型号" :require="true" />
        <Field name="phoneNum" v-model="phoneNum" label="报警电话" :require="true" />
        <Picker
          label="设备生产厂家"
          :require="true"
          name="eqFactory"
          :columns="eqUnitColumns"
          @confirm-values="(value) => (eqUnit = value.dicVal)"
        />
        <Picker
          label="监测气体 "
          :require="true"
          name="eqGas"
          :columns="gasTypeColumns"
          @confirm-values="(value) => (gasType = value.dicVal)"
        />
        <Picker
          label="生产日期 "
          :require="true"
          pickerType="time"
          name="makeDate"
        />
        <div class="btn-container">
          <van-button
            block
            type="primary"
            :loading="loading"
            loading-text="请稍后..."
            :disabled="loading"
            native-type="submit"
            @click="isclick = true"
          >
            确认添加
          </van-button>
        </div>
      </van-form>
    </div>
  </Popup>
</template>

<script>
import { Toast } from 'vant'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { getSelectList, isEqIdRepeat, addAlarm } from '@/api/customer'
export default {
  name: 'AddAlarm', // 新增报警器
  emits: ['add-alarm'],
  setup(props, { emit }) {
    const popup = ref(null)
    const showForm = ref(false)
    const userId = ref('')
    const showPopup = (data) => {
      userId.value = data
      showForm.value = true
      popup.value.showPopup()
    }

    // 获取select列表
    const eqUnit = ref('')
    const gasType = ref('')
    const eqUnitColumns = ref([])
    const gasTypeColumns = ref([])
    const getSelectListData = async () => {
      const eqUnitData = getSelectList(16)
      const gasTypeData = getSelectList(17)
      Promise.all([eqUnitData, gasTypeData]).then(([res1, res2]) => {
        eqUnitColumns.value = res1.data
        gasTypeColumns.value = res2.data
        console.log(res1, res2)
      })
    }
    getSelectListData()
    const asyncValidator = (val) =>
      new Promise((resolve) => {
        Toast.loading({
          message: '验证中...',
          duration: 0
        })
        console.log(val)
        isEqIdRepeat(val).then((res) => {
          Toast.clear()
          resolve(res.data === '0')
        })
      })
    const store = useStore()
    const mobile = computed(() => store.state.userInfo.telephone).value
    const phoneNum = ref(mobile)
    // 提交
    const loading = ref(false)
    const handleSubmit = (values) => {
      loading.value = true
      const params = {
        ...values,
        eqUnit: eqUnit.value,
        gasType: gasType.value,
        userId: userId.value
      }
      addAlarm(params)
        .then(() => {
          loading.value = false
          Toast.success('添加成功')
          popup.value.hidePopup()
          emit('add-alarm')
        })
        .catch(() => {
          loading.value = false
        })
    }
    return {
      popup,
      showPopup,
      handleSubmit,
      eqUnitColumns,
      gasTypeColumns,
      loading,
      eqUnit,
      gasType,
      asyncValidator,
      showForm,
      phoneNum
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin-bottom: 20px;
}
.container {
  background-color: #fff;
  padding: 20px 0;
  .btn-container {
    margin: 16px;
  }
}
</style>
